import { useState, useEffect, useCallback } from 'react';

const USER_STORAGE_KEY = 'kyc_user';

function getStorage() {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}

function getStoredUser() {
  const storage = getStorage();

  if (!storage) {
    return null;
  }

  try {
    const stored = storage.getItem(USER_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    try {
      storage.removeItem(USER_STORAGE_KEY);
    } catch {}
    return null;
  }
}

export function useAuth() {
  const [user, setUser] = useState(getStoredUser);

  const login = useCallback((userData) => {
    try {
      getStorage()?.setItem(USER_STORAGE_KEY, JSON.stringify(userData));
    } catch {}
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    try {
      getStorage()?.removeItem(USER_STORAGE_KEY);
    } catch {}
    setUser(null);
  }, []);

  return { user, login, logout, isAuthenticated: !!user };
}

export function useDebounce(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
